import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  CAR_BOX_INFO_LIST_REQUEST,
  CAR_INFO_LIST_REQUEST,
  WALLET_INFO_LIST_REQUEST,
  NFT_GEAR_INFO_LIST_REQUEST,
  BRIDGE_WALLET_INFO_REQUEST, PILOT_INFO_LIST_REQUEST,
} from '../../constants/monitoring/nftInfoConstants';
import {
  PerplayMonitoringApi,
  MonitoringControllerDtoNftCarListRequest,
  MonitoringControllerDtoNftBoxListRequest,
  MonitoringControllerDtoWalletListRequest,
  MonitoringControllerDtoGearNftListRequest,
  MonitoringControllerDtoSpendingWalletPrivateKeyRequest,
  MonitoringControllerDtoSpendingWalletPrivateKeyResponse,
  MonitoringControllerDtoPilotNftListRequest
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import MonitoringControllerDtoNftCarListResponse
  from '../../models/src/model/MonitoringControllerDtoNftCarListResponse';
import MonitoringControllerDtoNftBoxListResponse
  from '../../models/src/model/MonitoringControllerDtoNftBoxListResponse';
import MonitoringControllerDtoWalletListResponse
  from '../../models/src/model/MonitoringControllerDtoWalletListResponse';
import MonitoringControllerDtoGearNftListResponse
  from '../../models/src/model/MonitoringControllerDtoGearNftListResponse';
import MonitoringControllerDtoPilotNftListResponse
  from "../../models/src/model/MonitoringControllerDtoPilotNftListResponse";

const api = new PerplayMonitoringApi(config.API_CLIENT);

function* carInfoListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoNftCarListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.vehicleType = payload.vehicleType;
    requestData.vehicleGrade = payload.vehicleGrade;
    requestData.vehicleSeal = payload.vehicleSeal;
    requestData.minLevel = payload.minLevel;
    requestData.maxLevel = payload.maxLevel;
    requestData.isPlus = payload.isPlus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringNftCarListPost({ monitoringControllerDtoNftCarListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoNftCarListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* carBoxInfoListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoNftBoxListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.grade = payload.grade;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringNftBoxListPost({ monitoringControllerDtoNftBoxListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoNftBoxListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* walletInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoWalletListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.account = payload.account;
    requestData.walletNo = payload.walletNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringWalletListPost({ monitoringControllerDtoWalletListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoWalletListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftGearInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoGearNftListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.grade = payload.grade;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringGearNftListPost({ monitoringControllerDtoGearNftListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoGearNftListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* bridgeWalletInfoRequestSage(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoSpendingWalletPrivateKeyRequest();
    requestData.address = payload.address;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringGetSpendingWalletPrivateKeyPost({ monitoringControllerDtoSpendingWalletPrivateKeyRequest : requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoSpendingWalletPrivateKeyResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* pilotInfoListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new MonitoringControllerDtoPilotNftListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.account = Number(payload.account);
    requestData.nftUid = payload.nftUid;
    requestData.grade = payload.grade;
    requestData.skillType = payload.skillType;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMonitoringPilotNftListPost({ monitoringControllerDtoPilotNftListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MonitoringControllerDtoPilotNftListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftInfoRootSaga() {
  yield all([
    takeEvery(CAR_INFO_LIST_REQUEST, carInfoListRequestSaga),
    takeEvery(CAR_BOX_INFO_LIST_REQUEST, carBoxInfoListRequestSaga),
    takeEvery(WALLET_INFO_LIST_REQUEST, walletInfoRequestSaga),
    takeEvery(NFT_GEAR_INFO_LIST_REQUEST, nftGearInfoRequestSaga),
    takeEvery(BRIDGE_WALLET_INFO_REQUEST, bridgeWalletInfoRequestSage),
    takeEvery(PILOT_INFO_LIST_REQUEST, pilotInfoListRequestSaga),
  ]);
}

const nftInfoSagas = [fork(nftInfoRootSaga)];

export default nftInfoSagas;
